"use client";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import Image from "next/image";
import React, { useCallback, useEffect, useMemo, useState } from "react";
// import CountDown from "../claim-service/CountDown";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { ApiService } from "@/app/services/AppService";
import {
  OfferService,
  ResponseObject,
  ViewDetailsServices,
} from "@/app/classes/main";
import { FormatedTime } from "../genericComponents/formated-time/FormatedTime";
import ViewDetails from "../genericComponents/view-details/ViewDetails";
import { AddToCartService } from "../../services/cart";
import { getHubId } from "../genericComponents/helper-functions/currencyCode";
import { useCurrencyCode } from "../genericComponents/helper-functions/CurrencySymbol";
const CountDown = React.lazy(() => import("../claim-service/CountDown"));
import "./index.css";

export const Offers = ({}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [dynamicStyle, setDynamicStyle] = useState("");
  const [dealofDayData, setDealofDayData] = useState<OfferService | undefined>(
    undefined
  );
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<ViewDetailsServices | undefined>(undefined);
  const [reloadFlag, setReloadFlag] = useState(false);
  const apiService = useMemo(() => new ApiService(), []);
  const addTocartService = useMemo(() => new AddToCartService(), []);
  const currencyCode = useCurrencyCode();
  const xHubId = getHubId();
  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    // Check if we are in the browser (client-side)
    if (typeof window !== "undefined") {
      // Get the screen width when the component mounts (only on client-side)
      setScreenWidth(window.innerWidth);
    }
  }, []);

  const handleAddGift = async (e: any, index: any) => {
    e.stopPropagation();
    const service = dealofDayData?.servicesList?.[index];
    if (!service) {
      return;
    }
    let inCart = addTocartService.checkIfAvailableinCart(
      service.id ?? 0,
      service.cid ?? 0
    );
    if (inCart) {
      await addTocartService.addToCart(
        service.id ?? 0,
        false,
        service.cid ?? 0,
        service.coverImage?.secureHttpPath ?? "",
        service.aboutList,
        service.subHeading,
        service.serviceCharge,
        service.productCost,
        service.min,
        service.specialPrice,
        service.specialMessage
      );
    } else {
      await addTocartService.addToCart(
        service.id ?? 0,
        true,
        service.cid ?? 0,
        service.coverImage?.secureHttpPath ?? "",
        service.aboutList,
        service.subHeading,
        service.serviceCharge,
        service.productCost,
        service.min,
        service.specialPrice,
        service.specialMessage
      );
    }
    var newDealOfTheDay = { ...dealofDayData };
    newDealOfTheDay.servicesList = newDealOfTheDay?.servicesList?.map(
      (service: any, idx: any) => {
        if (idx === index) {
          return {
            ...service,
            inCart: addTocartService.checkIfAvailableinCart(
              service?.id,
              service?.cid
            ),
          };
        }
        return service;
      }
    );
    setDealofDayData(newDealOfTheDay);
    setReloadFlag(true);
  };

  const handleOpenViewDetails = (item: any) => {
    setData(item);
    setOpen(true);
  };

  const getDataDealOfTheDay = useCallback(async () => {
    try {
      const responseObject: ResponseObject | undefined =
        await apiService.get<ResponseObject>(
          apiService.dealOfTheDay,
          undefined,
          xHubId
        );
      let dealOfTheDay = responseObject?.object;
      dealOfTheDay.servicesList.forEach((service: any) => {
        service.inCart = addTocartService.checkIfAvailableinCart(
          service.id,
          service.cid
        );
      });
      setDealofDayData(dealOfTheDay);
    } catch (error) {
      console.log("Error:", error);
    }
  }, [apiService, addTocartService, xHubId]);

  useEffect(() => {
    getDataDealOfTheDay();
  }, [getDataDealOfTheDay]);

  const handleCardPosition = useCallback(() => {
    if (
      (dealofDayData &&
        dealofDayData?.servicesList &&
        dealofDayData?.servicesList?.length > 4) ||
      isSmallScreen ||
      screenWidth < 1425
    ) {
      setDynamicStyle("left");
    } else {
      setDynamicStyle("center");
    }
  }, [dealofDayData, isSmallScreen, screenWidth]);

  useEffect(() => {
    handleCardPosition();
  }, [isSmallScreen, handleCardPosition]);

  return (
    <>
      {dealofDayData &&
      dealofDayData?.servicesList &&
      dealofDayData?.servicesList?.length > 0 ? (
        <Box
          sx={{
            marginTop: { xs: "1rem", sm: "3rem" },
            background: { xs: "#15741a", sm: "#fff" },
            padding: { xs: "1rem 0px 0px", sm: "0px" },
          }}
        >
          <Grid
            item
            container
            xs={11.5}
            sm={11}
            md={9.5}
            lg={9.5}
            margin="auto"
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", color: { xs: "#fff", sm: "#000" } }}
              className="offer-heading"
            >
              Today&#39;s Offer
            </Typography>
            <Box
              sx={{
                textAlign: "center",
                flexDirection: "column",
                alignItems: "center",
                width: "100% ",
              }}
            >
              <Box
                sx={{
                  width: "auto",
                  textAlign: "center",
                  color: { xs: "#fff", sm: "#000" },
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                  margin: { xs: "0.5rem 1rem 0.5rem auto", sm: "auto" },
                }}
              >
                <Box sx={{ textAlign: "left" }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "14px", sm: "16px" },
                    }}
                  >
                    {dealofDayData?.heading}
                  </Typography>
                  <Typography variant="body2" sx={{}}>
                    {dealofDayData?.subheading}
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="body2"
                    sx={{ marginBottom: "0.5rem", fontWeight: "bold" }}
                  >
                    Offer Expire in
                  </Typography>
                  <Box
                    sx={{
                      fontWeight: "2rem",
                      transform: "scale(1.4)",
                    }}
                  >
                    {dealofDayData && dealofDayData?.expireIn && (
                      <CountDown
                        expireIn={dealofDayData?.expireIn}
                        offerTimerValid={true}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: dynamicStyle,
                  overflowX: "scroll",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  scrollbarWidth: "none", // Hide scrollbar for Firefox
                  msOverflowStyle: "none", // Hide scrollbar for IE/Edge
                }}
              >
                {dealofDayData?.servicesList?.map((item: any, index: any) => (
                  <Box
                    onClick={() => handleOpenViewDetails(item)}
                    key={index}
                    sx={{
                      cursor: "pointer",
                      minWidth: "16rem",
                      minHeight: "20rem",
                      width: "16rem",
                      height: "21rem",
                      borderRadius: "1rem",
                      overflow: "hidden",
                      position: "relative",
                      margin: { xs: "0.5rem", sm: "1rem" },
                      boxShadow: "2px 1px 4px 1px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    <Image
                      src={item?.coverImage?.secureHttpPath}
                      width={1000}
                      height={1000}
                      style={{
                        margin: "auto",
                        objectFit: "cover",
                        width: "16rem",
                        height: "21rem",
                        borderRadius: "1rem",
                        // background:
                        //   "linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))",
                      }}
                      alt="category"
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        background: "#c60606",
                        color: "white",
                        padding: "2px 4px",
                        overflow: "hidden",
                        lineHeight: "0px",
                        borderRadius: "0px 1rem 0px 3px",
                      }}
                    >
                      <Typography variant="body2">
                        {Math.floor(item?.discountInPercent)}% OFF
                      </Typography>
                      <Typography variant="caption">Less than usual</Typography>
                    </Box>
                    <Box
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        height: "80%",
                        background:
                          "linear-gradient(to top, rgba(0, 0, 0, 0.8) 75%, rgb(255 255 255 / 0%))",
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: "left",
                          padding: "8px",
                          bottom: 0,
                          position: "absolute",
                          width: "-webkit-fill-available",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: "white", marginBottom: "-4px" }}
                        >
                          {item?.name}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "white" }}>
                          {item?.subHeading}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            color: "white",
                          }}
                        >
                          <WatchLaterIcon sx={{ fontSize: "16px" }} />
                          <Typography
                            variant="caption"
                            sx={{ paddingLeft: "8px" }}
                          >
                            <FormatedTime min={item?.min} />
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            maxHeight: "7rem",
                            overflow: "scroll",
                            "&:: -webkit-scrollbar": {
                              display: "none",
                            },
                            marginBottom: "0.5rem",
                          }}
                        >
                          {item?.aboutList.map((item: any, index: any) => (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                              key={index}
                            >
                              <CheckIcon
                                sx={{
                                  color: "white",
                                  paddingRight: "5px",
                                  fontSize: "1rem",
                                }}
                              />
                              <Typography
                                variant="caption"
                                sx={{ color: "white" }}
                              >
                                {item}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                        {item?.specialPrice ? (
                          <Typography
                            variant="body2"
                            sx={{ color: "#a1f3a2", marginTop: "0.2rem" }}
                          >
                            Special Price &nbsp;
                            <span
                              style={{
                                color: "white",
                              }}
                            >
                              {currencyCode}
                              {item?.specialPrice?.toLocaleString()}/-
                            </span>
                          </Typography>
                        ) : (
                          ""
                        )}
                        <Typography variant="caption">
                          <span
                            style={{
                              textDecoration: item?.specialPrice
                                ? "line-through"
                                : "",
                              color: item?.specialPrice ? "#ffbf00" : "#fff",
                              fontWeight: item?.specialPrice ? "100" : "600",
                            }}
                          >
                            {currencyCode}
                            {item?.amount?.toLocaleString()}/-
                          </span>{" "}
                          &nbsp;
                          <span
                            style={{
                              textDecoration: "line-through",
                              color: "#ffbf00",
                            }}
                          >
                            {currencyCode}
                            {item?.mrp?.toLocaleString()}/-
                          </span>
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="caption"
                              sx={{ color: "#a1f3a2" }}
                            >
                              {item?.specialMessage}
                            </Typography>
                          </Box>
                          <Box>
                            {item?.inCart == null || !item?.inCart ? (
                              <AddIcon
                                fontSize="small"
                                style={{
                                  height: "1.8rem",
                                  width: "1.8rem",
                                  color: "#15741a",
                                  background: "white",
                                  padding: "4px",
                                  borderRadius: "10rem",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => handleAddGift(e, index)}
                              />
                            ) : (
                              <CheckIcon
                                fontSize="small"
                                style={{
                                  height: "1.8rem",
                                  width: "1.8rem",
                                  color: "#15741a",
                                  background: "white",
                                  padding: "4px",
                                  borderRadius: "10rem",
                                  cursor: "pointer",
                                  border: "1px solid #15741a",
                                }}
                                onClick={(e) => handleAddGift(e, index)}
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
          <ViewDetails
            open={open}
            setClose={() => setOpen(false)}
            imageUrl={
              data?.banner?.secureHttpPath ?? data?.coverImage?.secureHttpPath
            }
            heading={data?.name}
            id={data?.id}
            cid={data?.cid}
            servicedDetails={data?.aboutList}
            descriptions={data?.descriptions}
            amount={data?.specialPrice}
            min={data?.min}
            subHeading={data?.subHeading}
            mrp={data?.mrp}
            specialPrice={data?.specialPrice}
            specialMessage={data?.specialMessage}
            coin={data?.cashbackSalontymCoins}
            aboutList={data?.aboutList}
            serviceCharge={data?.serviceCharge}
            productCost={data?.productCost}
            reloadCartItemsFlag={() => {}}
            setReloadViewDetailsItem={() => setReloadFlag(false)}
            reloadViewDetailsItem={reloadFlag}
          />
        </Box>
      ) : (
        ""
      )}
    </>
  );
};
